export const connect = {
  pracAvatarAlt: "Avatar for {{pracName}}",
  header: {
    productName: "Connect",
    beta: "Beta",
  },
  pageHead: {
    backToProfile: "Back to profile",
    eyebrow: "Request appointment",
    title: "Create your account",
  },
  form: {
    alreadyHaveAnAccount: "Already have an account?",
    submitError: "Something went wrong. Please try again.",
  },
  checkEmail: {
    body: "We sent a link to <emailText>{{email}}</emailText> to confirm your email address and finish your request.",
    spamHint: "Didn't get the email? Check your spam folder.",
  },
  practitionerCard: {
    requestingAppointmentWith: "Requesting an appointment with",
    typeAndLocation: "{{practitionerType}} · {{location}}",
    firstVisit: "First visit",
    subsequentVisit: "Subsequent visit",
    visitPriceAndDuration: "{{price}} · {{durationMinutes}} min",
    freeVisitDuration: "Free {{durationMinutes}}-min",
  },
  nextSteps: {
    title: "What happens next",
    pickATime: "Pick a time on {{pracFirstName}}'s calendar.",
    requestGoesToOffice: "Your request goes straight to {{pracFirstName}}'s office.",
    joinStore:
      "After you create an account, you will join {{pracFirstName}}'s Fullscript store, where you can browse their protocols and collections, access your treatment plans, and update your information.",
  },
} as const;
